import React from "react";
import SEO from "../components/SEO";
import PageTitle from "../components/PageTitle";
import Breadcrumb from "../components/Breadcrumb";

const PrivacyPolicy = () => {
  return (
    <>
      <SEO
        title="Gizlilik & Politika | WiaSoft"
        description="WiaSoft gizlilik politikası ve kişisel verilerinizin nasıl korunduğu"
        type="website"
      />
      <PageTitle title="Gizlilik & Politika" />
      <Breadcrumb title="Gizlilik & Politika" />
      
      <section className="services-area">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="service-content">
                <h2>Gizlilik & Politika</h2>
                
                <h3>1. Gizlilik Politikamız</h3>
                <p>
                  WiaSoft, sizin gizliliğinizi önemsemektedir. Bu politika, web sitemizi kullanırken 
                  topladığımız ve kullandığımız bilgiler hakkında açıklama yapmaktadır.
                </p>

                <h3>2. Toplanan Bilgiler</h3>
                <p>
                  Sitemizi ziyaret ettiğinizde, bazı kişisel bilgiler (ad, e-posta, telefon numarası vb.) 
                  tarafınızdan gönüllü olarak sağlanabilir. Bunun yanında, teknik bilgiler otomatik olarak 
                  toplanabilir.
                </p>

                <h3>3. Bilgilerin Kullanımı</h3>
                <p>
                  Toplanan bilgiler, size daha iyi hizmet sunmak, iletişim kurmak ve hizmetlerimizi 
                  geliştirmek amacıyla kullanılmaktadır. Bilgileriniz izniniz olmaksızın üçüncü taraflara 
                  verilmez.
                </p>

                <h3>4. Çerezler (Cookies)</h3>
                <p>
                  Sitemiz, kullanıcı deneyimini geliştirmek için çerezler kullanabilir. Çerezler, tarayıcınızda 
                  saklanan küçük dosyalardır ve sizi tanımlamamıza yardımcı olur.
                </p>

                <h3>5. Veri Güvenliği</h3>
                <p>
                  Kişisel verileriniz şifrelenmiş bağlantılar üzerinden iletilir ve güvenli sunucularda 
                  depolanır. Ancak, hiçbir veri aktarımı %100 güvenli olamayacağını unutmayınız.
                </p>

                <h3>6. Haklarınız</h3>
                <p>
                  Hakkınız olan bilgilerinizi isteme, düzeltme ve silme talebinde bulunabilirsiniz. 
                  Bu konuda bizimle iletişime geçebilirsiniz.
                </p>

                <h3>7. Değişiklikler</h3>
                <p>
                  Bu gizlilik politikası değiştirilme hakkı saklıdır. Değişiklikler bu sayfada 
                  yayınlandığında yürürlüğe girecektir.
                </p>

                <h3>8. İletişim</h3>
                <p>
                  Gizlilik politikası hakkında sorularınız varsa, lütfen bizimle iletişime geçiniz.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;
